import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const pictogramStyles = url => css`
  background-image: url(${url});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;
export const standardGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(2, auto);

  .upsell {
    grid-area: 1 / 1 / 2 / 3;
    margin-bottom: 8px;
  }

  .title {
    grid-area: 2 / 2 / 3 / 3;

    @media (min-width: ${breakpoints._768}) {
      grid-area: 2 / 1 / 3 / 3;
    }
  }

  .children {
    display: contents;
  }

  .pictogram {
    height: 2rem;
    margin-inline-end: 8px;
    margin-top: 2px;
    width: 2rem;
  }
`;
export const headerWrapperStyles = css`
  padding-inline-start: 0;
`;
export const titleStyles = css`
  align-items: center;
  font-weight: 700;

  @media (min-width: ${breakpoints._768}) {
    font-size: 1.375rem;
  }
`;
//# sourceMappingURL=styles.js.map